const CONSTANTS = {
  token: 'Kresus-KPMG-auth-v1rf567',
};

export default CONSTANTS;
